import type { ComponentType } from 'react';
import { lazy } from '@atlassian/react-loosely-lazy';
import type { Props } from './types.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const AsyncLazyNumberFieldInlineEdit = lazy<ComponentType<Props>>(
	() => import(/* webpackChunkName: "async-issue-field-number-inline-edit" */ './index'),
);
